import { useState } from "react"
import axios from "axios";
import dayjs from "dayjs";

import { Spin, Modal } from "antd";
import createImagePromptGPT from "./controller/createImagePromptGPT";
import createImageGPT from "./controller/createImageGPT";
import s3Controller from "controllers/s3Controller";

const backend = process.env.REACT_APP_BACKEND;

function CreateImage({ record, gptModel, dataChangeHandler }) {
  const [loading, setLoading] = useState(false)

  const createImage = (e) => {
    e.stopPropagation();
    const prompt = record.final_prompt

    if(prompt) {
      setLoading(true)
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");
      const fileName = `wordimage_${record.id}_${currentVer}.jpeg`;
      const size = gptModel.image_size

      createImageGPT(fileName, size,  prompt)
      .then(imageFile=>{
        s3Controller.s3Upload(imageFile,"word_image",(err, data)=>{
          //업로드가 완료되었을 경우 콜백
          if (err) {
            console.log(err)
            Modal.error({
              title:"에러",
              okText:"확인",
              content:"s3에 업로드 중 에러가 발생해서 생성을 취소했습니다."
            })
          } else {
            const newKey = data.Key
            const newFile = data.Key.split("/")[1]
            axios.post(`${backend}/contents/new_word/image/new-image/${record.id}`,
            {newFile, size})
            .then(res=>{
              const instance = {...record}
              instance.image_count = instance.image_count + 1
              dataChangeHandler(instance, "image_count")
              setLoading(false)
            })
            .catch(err=>{
              console.log(err)
              setLoading(false)
              s3Controller.s3DeleteFile(newKey, (err, data) => {
                if (err) console.log(err);
              });
              Modal.error({
                title:"에러",
                okText:"확인",
                content:"서버 에러가 발생해서 이미지를 저장하지 못했습니다."
              })
            })
          }
        })
        
      })
      .catch(err=>{
        setLoading(false)
        console.log(err)
        Modal.error({
          title:"에러",
          okText:"확인",
          content:"AI 에러가 발생해서 문장을 생성하지 못했습니다."
        })
      })
    }
  }
  
  const deleteImage = (e) => {
    e.stopPropagation();
    if(record.image_count) {
      setLoading(true)
      axios.delete(`${backend}/contents/new_word/image/new-image/${record.id}`)
      .then(res=>{
        const files = res.data.data.map(el=>{
          return {Key: "word_image/"+el.word_image_filename}
        })
        s3Controller.s3DeleteFiles(files,(err,data)=>{
          if (err) console.log(err)
        })
        const instance = {...record}
        instance.image_count = null
        dataChangeHandler(instance, "image_count")
      })
      .catch(err=>{
        console.log(err)
      })
      .finally(()=>[
        setLoading(false)
      ])
    }
  }

  // const createMeaningPrompt = (e) => {
  //   e.stopPropagation();
  //   if(!record.translate_text) return

  //   const meaningPrompt_1 = prompt.meaningPrompt.replace(/{word_en}/gi,record.word)
  //   const meaningPrompt = meaningPrompt_1.replace(/{word_ko}/gi,record.translate_text)

  //   setLoading(true)
  //   createImagePromptGPT(meaningPrompt, gptModel.gpt_model)
  //   .then(newPrompt=>{
  //     let onlyPrompt = newPrompt
  //     if(newPrompt[0] === `"`) {
  //       onlyPrompt = newPrompt.slice(1,-1)
  //     }
  //     const value = {
  //       id: record.dalle_id,
  //       WordExMaster_id: record.id,
  //       meaning_prompt: onlyPrompt
  //     }
  //     axios.post(`${backend}/contents/new_word/image/meaning_prompt`,{value})
  //     .then(res=>{
  //       const instance = {...record}
  //       instance.meaning_prompt = onlyPrompt
  //       instance.dalle_id = res.data.data
  //       dataChangeHandler(instance, "meaning_prompt")
  //     })
  //     .catch(err=>{
  //       console.log(err)
  //       Modal.error({
  //         title:"에러",
  //         okText:"확인",
  //         content:"서버 에러가 발생해서 프롬프트를 생성하지 못했습니다."
  //       })
  //     })
  //   })
  //   .catch(err=>{
  //     console.log(err)
  //     Modal.error({
  //       title:"에러",
  //       okText:"확인",
  //       content:"AI 에러가 발생해서 프롬프트를 생성하지 못했습니다."
  //     })
  //   })
  //   .finally(()=>{
  //     setLoading(false)
  //   })
  // }
  // const deleteMeaningPrompt = (e) => {
  //   e.stopPropagation();
  //   if(record.meaning_prompt) {
  //     setLoading(true)
  //     axios.delete(`${backend}/contents/new_word/image/meaning_prompt/${record.id}`)
  //     .then(res=>{
  //       const instance = {...record}
  //       instance.meaning_prompt = null
  //       dataChangeHandler(instance, "meaning_prompt")
  //     })
  //     .catch(err=>{
  //       console.log(err)
  //     })
  //     .finally(()=>[
  //       setLoading(false)
  //     ])
  //   }
  // }

  return (
    <div>
      <Spin spinning={loading}>
        <a style={{ margin: "0px 5px", whiteSpace: "pre" }} disabled={!record.final_prompt} onClick={(e) => createImage(e)}>생성</a>
        <a style={{ margin: "0px 5px", whiteSpace: "pre" }} disabled={!record.image_count} onClick={(e) => deleteImage(e)}>삭제</a>
      </Spin>
    </div>
  )
}

export default CreateImage